module.exports = __webpack_public_path__ + "img/history-dark.673da623.png";